import { connect } from 'react-redux';
import {
  GET_DATA_SAMPLES_REQUEST,
  GET_DATA_CHARACTERISTICS_REQUEST,
} from '../../../constants/actionTypes';
import { fetchDataSamples, fetchCharacteristics } from '../../../actions';
import { getSamplesForDataSet } from '../../../reducers/selectors';
import AvailableDataSetDataBrowser from './AvailableDataSetDataBrowser';

const mapStateToProps = (state, ownProps) => {
  const { data } = ownProps;

  if (data) {
    const { request, dataSetSchemas } = state;
    return {
      dataSetSchema: dataSetSchemas[data.id],
      dataSetSamples: getSamplesForDataSet(state, ownProps),
      isLoadingSamples: !!(
        request[GET_DATA_SAMPLES_REQUEST] || request[GET_DATA_CHARACTERISTICS_REQUEST]
      ),
    };
  }

  return {
    dataSetSamples: getSamplesForDataSet(state, ownProps),
    isLoadingSamples: true,
  };
};

export default connect(mapStateToProps, {
  fetchDataSamples,
  fetchCharacteristics,
})(AvailableDataSetDataBrowser);
